import { ApiUtility } from "./ApiUtility";

class PravachansService {
  pravachanRoute = "/api/pravachans?lang=";
  categoryRoute = "/api/settings/filters?lang=";
  pravachanAuthorCount = "/api/Pravachans/AuthorCount?lang=";
  pravachanCategoryRoute = "/api/Pravachans/Categories?lang=";
  recordCountRoute = "/api/Settings/FilterRecordCount";
  pravachanByIdPath = "/api/Pravachans/";

  getFilters = (lang: string, productFor: string) => {
    return ApiUtility.get(
      this.categoryRoute + lang + "&productFor=" + productFor
    );
  };

  getPravachans = (
    lang: string,
    start: number,
    length: number,
    IsChildLiterature: boolean,
    categoryId: string,
    authorId: string,
    search: string,
    sort: string,
    langId: string,
    isSpecial: boolean,
    month: string,
    year: string
  ) => {
    return ApiUtility.get(
      this.pravachanRoute +
        lang +
        "&start=" +
        start +
        "&length=" +
        length +
        "&categoryId=" +
        categoryId +
        "&IsChildLiterature=" +
        IsChildLiterature +
        "&authorId=5bbc60101fd2d735b0087d36" +
        "&search=" +
        search +
        "&sort=" +
        sort +
        "&bookLangauge=" +
        langId +
        "&isSpecial=" +
        isSpecial +
        "&month=" +
        month +
        "&year=" +
        year
    );
  };

  getMobilePravachanCategory = (lang?: string) => {
    return ApiUtility.get(this.pravachanCategoryRoute + lang);
  };

  getMobilePravachanAuthorCount = (lang?: string) => {
    return ApiUtility.get(this.pravachanAuthorCount + lang);
  };

  getPravachanAuthorCount = (lang?: string) => {
    return ApiUtility.get(this.pravachanAuthorCount + lang);
  };

  getMobileRecordCount = (
    filterfor: string,
    productFor: string,
    categoryId?: string,
    language?: string,
    authorId?: string,
    subjectId?: string
  ) => {
    let url =
      this.recordCountRoute +
      "?filterfor=" +
      filterfor +
      "&productFor=" +
      productFor;
    if (categoryId) url += "&categoryId=" + categoryId;
    if (language) url += "&language=" + language;
    if (authorId) url += "&authorId=" + authorId;
    if (subjectId) url += "&subjectId=" + subjectId;
    return ApiUtility.get(url);
  };

  getMobilePravachanById = (id: string, lang?: string, userId?: string) => {
    let url = this.pravachanByIdPath + id + "?lang=" + lang;
    if (userId) {
      url += "&userId=" + userId;
    }
    return ApiUtility.get(url);
  };

  getRecordCount = (
    filterfor: string,
    productFor: string,
    categoryId?: string,
    language?: string,
    authorId?: string,
    subjectId?: string
  ) => {
    let url =
      this.recordCountRoute +
      "?filterfor=" +
      filterfor +
      "&productFor=" +
      productFor;
    if (categoryId) url += "&categoryId=" + categoryId;
    if (language) url += "&language=" + language;
    if (authorId) url += "&authorId=" + authorId;
    if (subjectId) url += "&subjectId=" + subjectId;
    return ApiUtility.get(url);
  };
}
export default new PravachansService();
